import React from 'react'
import { Button } from 'react-bootstrap'
import { CSVLink } from 'react-csv'
import { saveAs } from 'file-saver'
import * as XLSX from 'xlsx'
import { FaFileCsv, FaFileExcel } from 'react-icons/fa'

export type ExportRow = Record<string, string | number | boolean | null | undefined>

type TableExportActionsProps = {
    data: ExportRow[]
    filename: string
    className?: string
    disabled?: boolean
}

export const sanitizeExportFilename = (value: string) => {
    return value
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '') || 'export'
}

export const exportRowsToExcel = (data: ExportRow[], filename: string) => {
    const worksheet = XLSX.utils.json_to_sheet(data)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')
    const workbookOutput = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
    saveAs(new Blob([workbookOutput], { type: 'application/octet-stream' }), `${sanitizeExportFilename(filename)}.xlsx`)
}

const actionButtonStyle: React.CSSProperties = {
    borderRadius: '999px',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.4rem',
    lineHeight: 1,
}

export const TableExportActions: React.FC<TableExportActionsProps> = ({
    data,
    filename,
    className,
    disabled = false,
}) => {
    const hasData = !disabled && data.length > 0

    return (
        <div className={className || 'd-flex flex-wrap gap-2'}>
            {hasData ? (
                <CSVLink
                    data={data}
                    filename={`${sanitizeExportFilename(filename)}.csv`}
                    style={{ textDecoration: 'none' }}
                >
                    <Button variant="outline-secondary" size="sm" style={actionButtonStyle}>
                        <FaFileCsv size={13} />
                        <span>CSV</span>
                    </Button>
                </CSVLink>
            ) : (
                <Button variant="outline-secondary" size="sm" style={actionButtonStyle} disabled>
                    <FaFileCsv size={13} />
                    <span>CSV</span>
                </Button>
            )}

            <Button
                variant="outline-success"
                size="sm"
                style={actionButtonStyle}
                onClick={() => exportRowsToExcel(data, filename)}
                disabled={!hasData}
            >
                <FaFileExcel size={13} />
                <span>Excel</span>
            </Button>
        </div>
    )
}